const modules = require.context("./", false, /\.js$/);

const tools = {};
let combinedToolsArray = [ 
];
modules.keys().forEach((fileName) => {
  if (fileName !== "./index.js") {
    const module = modules(fileName);
    if (module.default) {
      Object.entries(module.default).forEach(([name, toolFunction]) => {
        if (typeof toolFunction === "function") {
          tools[name] = toolFunction;
        }
        if (Array.isArray(toolFunction)) {
          combinedToolsArray = [...combinedToolsArray, ...toolFunction]
        }
      });
    } else {
      console.warn(`⚠️ No default export found in ${fileName}`);
    }
  }
});

export default tools;
export const toolsArray = combinedToolsArray;